import React from 'react'
import { Icon, minorScale, majorScale, defaultTheme } from 'evergreen-ui'
import CircleIconWrapper from 'components/Icons/CircleIconWrapper'

const WarehouseIcon = ({ children }) => (
  <CircleIconWrapper
    background="greenTint"
    margin={0}
    size={majorScale(3)}
    icon={
      <Icon
        size={minorScale(3)}
        icon="database"
        color={defaultTheme.palette.green.base}
      />
    }
  />
)

export default WarehouseIcon
